import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { QUOTAION_API_PATH } from "../constants";
import { SurchargesPayload } from "@/core/interfaces/state/quotationManagmentState.interface";

class QuotationService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public async applySurcharges(
    payload: SurchargesPayload,
  ): Promise<ICoreResponse> {
    return this.restClient.post(
      `${QUOTAION_API_PATH.APPLY_SURCHARGES_XI}`,
      payload,
    );
  }
}

export default QuotationService;
